import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {WarningTheme} from './constants';
import {MPWarningAttrs} from './types';
import css from './index.styl?inline';
import {Template as template} from './template';

export class MPWarning extends Component<EmptyObj, MPWarningAttrs> {
  static get attrsSchema(): AttrsSchema<MPWarningAttrs> {
    return {
      ...super.attrsSchema,
      'body-text': `string`,
      'cta-href': `string`,
      'cta-text': `string`,
      'header-text': `string`,
      theme: {type: `string`, default: WarningTheme.Default, enum: Object.values(WarningTheme)},
      'img-src': `string`,
      small: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleCtaClick: (ev: MouseEvent) => {
          ev.preventDefault();
          this.dispatchEvent(new CustomEvent(`ctaClick`));
        },
      },
    };
  }
}
type JsxProps = {
  attrs: {
    bodyText?: string;
    ctaHref?: string;
    ctaText?: string;
    headerText?: string;
    theme?: WarningTheme;
    imgSrc?: string;
    small?: boolean;
  };
};

export const WarningEl = defineAndMakeJsxFactory<JsxProps>(`mp-warning`, MPWarning);
export const WarningReact = panel2react<JsxProps>(`mp-warning`, MPWarning);
